// removed by extract-text-webpack-plugin
module.exports = {"publicsection":"wmf-1vCMqm6z","publlictitle":"wmf-27SZvCyU","required":"wmf-yOLDnX-o","informationtitle":"wmf-18l-MjWL","titles":"wmf-dMfA4UOp","skustyle":"wmf-iHFIgp-8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/commoditymanagement/addcompleteinformation/medicalequipmentnonhaitao/medical-equipmentn-onhaitao.module.less
// module id = 438
// module chunks = 0